import React from 'react';

const Privacy = () => {
  return (
    <main className="flex-grow container mx-auto px-4 py-8">
      {/* Hero section */}
      <div className="bg-gradient-to-r from-purple-600 to-indigo-800 rounded-xl shadow-lg mb-12 p-8 text-white">
        <h1 className="text-3xl md:text-4xl font-bold mb-4">
          Adatvédelmi tájékoztató
        </h1>
        <p className="text-xl">
          Adatkezelési információk a pályázati folyamathoz
        </p>
      </div>

      <div className="bg-gradient-to-br from-purple-100 to-indigo-100 rounded-xl shadow-lg p-8 border border-purple-200">
        <div className="prose prose-purple max-w-none">
          <h2>Adatkezelési tájékoztató</h2>
          
          <p>A Webforyou Kft. (továbbiakban: Adatkezelő) online tevékenységével kapcsolatban kezeli a regisztrált felhasználók személyes adatait, kiemelten figyelmet fordítva az adatok biztonságára és a felhasználók jogainak védelmére.</p>

          <h3>1. Az adatkezelő adatai</h3>
          <ul>
            <li>Cégnév: Webforyou Kft.</li>
            <li>E-mail: nagyroland@webforyou.hu</li>
            <li>Telefon: +36 70 908 3086</li>
          </ul>

          <h3>2. A kezelt adatok köre</h3>
          <p>A pályázati jelentkezés során az alábbi személyes adatokat kezeljük:</p>
          <ul>
            <li>Kapcsolattartó neve</li>
            <li>E-mail cím</li>
            <li>Telefonszám</li>
            <li>Cég neve</li>
          </ul>

          <h3>3. Az adatkezelés célja</h3>
          <p>Az adatkezelés célja a NEUM pályázati folyamatban való részvétel biztosítása, kapcsolattartás és a szolgáltatás nyújtása.</p>

          <h3>4. Az adatkezelés jogalapja</h3>
          <p>Az adatkezelés jogalapja az Ön hozzájárulása, amelyet a jelentkezési űrlap kitöltésével ad meg.</p>

          <h3>5. Az adatkezelés időtartama</h3>
          <p>A személyes adatokat a pályázati folyamat lezárását követő 5 évig őrizzük meg.</p>

          <h3>6. Az Ön jogai</h3>
          <ul>
            <li>Hozzáférési jog</li>
            <li>Helyesbítéshez való jog</li>
            <li>Törléshez való jog</li>
            <li>Adatkezelés korlátozásához való jog</li>
            <li>Adathordozhatósághoz való jog</li>
          </ul>

          <h3>7. Adatbiztonság</h3>
          <p>Az Adatkezelő megfelelő technikai és szervezési intézkedéseket hajt végre annak érdekében, hogy garantálja az Ön személyes adatainak biztonságát.</p>

          <h3>8. Kapcsolatfelvétel</h3>
          <p>Adatvédelemmel kapcsolatos kérdéseivel kérjük, forduljon hozzánk bizalommal az alábbi elérhetőségeken:</p>
          <ul>
            <li>E-mail: nagyroland@webforyou.hu</li>
            <li>Telefon: +36 70 908 3086</li>
          </ul>
        </div>
      </div>
    </main>
  );
};

export default Privacy; 